import React from 'react';
import { Icons } from "../../Components"

import type { AuthStrategyIdentifierProps } from '../api/types';
import { AuthenticateHelpers } from '../api';
import { useColors } from '../../constants/useColors';
import { Text, View, TextInput } from '../../Components/Themed';
import type { FocusPositionProps } from '../../types';

type AuthStrategyIdentifierCardProps = {
    auth_strategy_identifier:AuthStrategyIdentifierProps,
    auth_request?: any,
    auto_focus?:boolean,
    onFocusPosition?:(data:FocusPositionProps) => void,
    onChangeIdentifier: (text:string,  is_valid:boolean, pretty_value?:string) => void 
}

const AuthStrategyIdentifier = ({ auth_strategy_identifier, onFocusPosition, auto_focus, auth_request, onChangeIdentifier }:AuthStrategyIdentifierCardProps) => {
    const C = useColors();

    const getAttributeIcon = (attribute:string) => {
        switch(attribute){
            case 'email': return <Icons.EmailIcon size={20} color={C.text.h1}/>
            case 'phone': return <Icons.PhoneIcon size={20} color={C.text.h1} />
            case 'username': return <Icons.UserIcon size={20} color={C.text.h1} />
            default: return <Icons.UserIcon size={20} color={C.text.h1} />
        }
    }

    if(!auth_strategy_identifier.auth_identifier){ return <></> }
    const is_valid = AuthenticateHelpers.isAttributeValid(auth_request.attribute, auth_request.value)

    return (
        <View style={{ margin:10 }}>
            <Text theme='h1'>{auth_strategy_identifier.label}</Text>
            <Text theme='h2'>{auth_strategy_identifier.description}</Text>
            <View  type='input' style={{ marginTop:15, flexDirection:'row', alignItems:'center' }}>
                <View transparent style={{ paddingLeft:10, paddingRight:15 }}>
                {getAttributeIcon(auth_strategy_identifier.auth_identifier.attribute)}
                </View>
                <TextInput
                    style={{ flex:1 }}
                    onFocusPosition={onFocusPosition}
                    value={auth_request.pretty_value ?? auth_request.value}
                    transparent
                    placeholder={`${auth_strategy_identifier.label}`}
                    autoFocus={auto_focus}
                    onChangeText={(text) => {
                        let pretty_value:string | undefined = undefined
                        if(auth_request.attribute == 'phone'){
                            text = AuthenticateHelpers.unformatPhone(text)
                            pretty_value = AuthenticateHelpers.formatPhone(text)
                        }
                        onChangeIdentifier(text, is_valid.valid, pretty_value)
                    }}
                />
                {auth_request.value ?
                <View transparent style={{ padding:10 }}>
                    { is_valid.valid ?
                    <Icons.CheckCirlceIcon color={C.text.success} size={14} />
                    :
                    <Icons.AlertIcon color={C.text.warning} size={14} />
                    }
                </View>
                :<></>}
            </View>
            {auth_request.value && !is_valid.valid ?
            <Text style={{ marginTop:2 }} textAlign='center' theme='warning'>{is_valid.error}</Text>
            :<></>}
        </View>
    )
}

export default AuthStrategyIdentifier